import 'lib/globals';
import { install } from "resize-observer";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import { createBrowserHistory } from 'history';
import { getLogger } from './lib/utils/logging';
import 'app/demo/theme-v1.scss'; // v1 dark/futuristic theme override (must load last)
import { DEMO_MODE } from 'app/demo/demoConfig';

// DEMO: wipe any stale cached state so every load reflects the current dummy
// dataset (prevents empty screens from old IndexedDB / rolled-over dates).
if (DEMO_MODE && typeof window !== 'undefined') {
    try { window.indexedDB && window.indexedDB.deleteDatabase('adaya'); } catch (e) {}
    try { window.localStorage && window.localStorage.clear(); } catch (e) {}
}

// support resize actions for older browsers
if (typeof window.ResizeObserver == 'undefined') {
    install();
}

// mount app
let app = document.getElementById('app');
if (app) {
    ReactDOM.render(
        <App />
    , app);
}

if (process.env.NODE_ENV != 'production') {
    console.log("App started. NODE_ENV: " + process.env.NODE_ENV + ', API_URL: ' + process.env.API_URL);
}

// preconfigure loggers
getLogger('error', 'red');
